/**
 * @generated SignedSource<<561cfd0883d7cf08517f09025354a76a>>
 * @relayHash f91e9769c2224ef6537429ff8eeeb48b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a216d9d8e29f9f633b18a89297380a5f81b34bdb221c9e18da37c9f456697f42

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraDevInfoConfigErrorType = "INCAPABLE" | "NOT_CONFIGURED" | "UNAUTHORIZED" | "UNKNOWN_CONFIG_ERROR" | "%future added value";
export type BranchDetailsPopupViewBranchDetailsPopupViewQuery$variables = {
  issueId: string;
};
export type BranchDetailsPopupViewBranchDetailsPopupViewQuery$data = {
  readonly graphStore: {
    readonly issueAssociatedBranch: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly container?: {
            readonly name?: string | null | undefined;
          } | null | undefined;
          readonly name?: string | null | undefined;
          readonly url?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly issueById: {
      readonly linkedBranches: {
        readonly configErrors: ReadonlyArray<{
          readonly dataProviderId: string | null | undefined;
          readonly errorType: JiraDevInfoConfigErrorType | null | undefined;
        }> | null | undefined;
        readonly details: ReadonlyArray<{
          readonly entityUrl: AGG$URL | null | undefined;
          readonly name: string | null | undefined;
          readonly scmRepository: {
            readonly name: string | null | undefined;
          } | null | undefined;
        }>;
      } | null | undefined;
    };
  };
};
export type BranchDetailsPopupViewBranchDetailsPopupViewQuery = {
  response: BranchDetailsPopupViewBranchDetailsPopupViewQuery$data;
  variables: BranchDetailsPopupViewBranchDetailsPopupViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "filterLegacy": true
    }
  }
],
v3 = {
  "concreteType": "JiraDevInfoConfigError",
  "kind": "LinkedField",
  "name": "configErrors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dataProviderId"
    },
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "concreteType": "JiraDevOpsBranchDetails",
  "kind": "LinkedField",
  "name": "details",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "entityUrl"
    },
    {
      "concreteType": "JiraScmRepository",
      "kind": "LinkedField",
      "name": "scmRepository",
      "plural": false,
      "selections": (v5/*: any*/)
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "url"
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "ExternalRepository"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueById",
                "plural": false,
                "selections": [
                  {
                    "args": (v2/*: any*/),
                    "concreteType": "JiraIssueBranches",
                    "kind": "LinkedField",
                    "name": "linkedBranches",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v6/*: any*/),
                        "action": "THROW",
                        "path": "jira.issueById.linkedBranches.details"
                      }
                    ],
                    "storageKey": "linkedBranches(input:{\"filterLegacy\":true})"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.issueById"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchConnection",
            "kind": "LinkedField",
            "name": "issueAssociatedBranch",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalBranch"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueById",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraIssueBranches",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": "linkedBranches(input:{\"filterLegacy\":true})"
              },
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchConnection",
            "kind": "LinkedField",
            "name": "issueAssociatedBranch",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalBranch"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a216d9d8e29f9f633b18a89297380a5f81b34bdb221c9e18da37c9f456697f42",
    "metadata": {},
    "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aa501b66ec944036d33defe26ab72b91";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
